import { render } from "./LineHeight.vue?vue&type=template&id=5c8653da"
import script from "./LineHeight.vue?vue&type=script&lang=ts"
export * from "./LineHeight.vue?vue&type=script&lang=ts"
script.render = render

export default script